import {
  EventStateManager,
  PollingOptimisticEventStateSync,
  StateWithHistory,
} from "../../alias";
import { eventSyncAdapterFactory } from "../eventSyncAdapterFactory";
import { LobbySyncAdapterProps } from "../lobby";
import {
  GameCommandByPlayer,
  GameReducerFactoryProps,
  gameReducerFactory,
} from "./gameReducerFactory";
import { UndoCommand } from "./undoApi";

export type GameWithHistory<Game, GameCommand> = StateWithHistory<
  Game,
  GameCommandByPlayer<GameCommand>
>;

export const gameStateManagerFactory = <Game, GameCommand>({
  gameId,
  playerIds,
  initGame,
  syncAdapterProps,
  gameReducerFactoryProps,
}: {
  gameId: string;
  playerIds: string[];
  initGame: Game;
  syncAdapterProps: LobbySyncAdapterProps;
  gameReducerFactoryProps: GameReducerFactoryProps<Game, GameCommand>;
}) => {
  const { gameReducerWithUndo, gameReducer } = gameReducerFactory(
    gameReducerFactoryProps
  );
  const eventStateManager = new EventStateManager(
    {
      initState: {
        gameState: initGame,
        undoState: { playerIds, answers: {} },
      },
      steps: [],
    },
    gameReducerWithUndo
  );
  const eventSyncAdapter = eventSyncAdapterFactory<GameCommand | UndoCommand>({
    ...syncAdapterProps,
    gameId,
  });
  const pollingSync = new PollingOptimisticEventStateSync(
    eventStateManager,
    eventSyncAdapter,
    2000
  );

  return { pollingSync, gameReducer };
};
